import React from 'react';
import Switcher from '../../../../../../components/common/switcher/Switcher';
import { Division } from '../../../../../../models/productDivision/types';
import { BrandCompany, Product } from '../../../../../../models/product/types';
import { ProductReferences } from '../../../../../../redux/actions/productActions/types';
import { blueDark01, blueLink } from '../../../../../../styles/colors';
import {
    ProductSwitcherContent,
    Text,
    InvisibleButton,
} from '../../../../../../styles/common.styles';

import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import SectionItem from '../guidelineSectionItem/GuidelineSectionItem';
import { OpenCloseDivisionButton } from '../../../../../../components/favoritProducts/favoriteDivisionItem/FavoriteDivisionItem.styles';
import {
    DivisionItemContainer,
    DivisionItemWrapper,
    DivisionTitle,
    DivisionTitleContainer,
    ExportDivisionImage,
} from '../../../../../projectInfo/tabs/productsTab/divisionItem/DivisionItem.styles';
import { useModalState } from '../../../../../../hooks/modalState';
import LiveGuidelineExportModal from '../../../../LiveGuidelinesList/LiveGuidelineExportModal';

interface Props {
    liveGuidelineId: number;
    liveGuidelineName: string;
    division: Division<Product>;
    references: ProductReferences | null;
    canHideProducts: boolean;
    editable: boolean;
    brandsInfo: Array<BrandCompany>;
    filterModalOpened?: boolean;
    selectedProducts?: Product[];
    handleClicked: (id: string) => void;
    handleSectionOpen: (divisionId: string, sectionId: string) => void;
    updateDivisions: (product: Product, isInstalled?: boolean) => void;
    handleDeleteProduct: (product: Product) => void;
    handleSelectProduct: (e: CheckboxChangeEvent, product: Product) => void;
}
const GuidelineDivisionItem: React.FC<Props> = ({
    liveGuidelineId,
    liveGuidelineName,
    division,
    references,
    canHideProducts,
    editable,
    brandsInfo,
    handleClicked,
    handleSectionOpen,
    updateDivisions,
    handleDeleteProduct,
    filterModalOpened,
    handleSelectProduct,
    selectedProducts,
}) => {
    const { isOpen, onToggle } = useModalState();

    const handleDivisionClicked = () => {
        handleClicked(division.id);
    };
    const handleSectionClicked = (sectionId: string) => {
        handleSectionOpen(division.id, sectionId);
    };

    const openCloseDivision = async () => {
        const action = checkWhatActionNeeded();
        openCloseDivisionProcess(action);
    };
    const checkWhatActionNeeded = () => {
        if (!division.clicked) {
            return true;
        }
        for (let j = 0; j < division.sections.length; j++) {
            const section = division.sections[j];
            if (!section.clicked) {
                return true;
            }
        }
        return false;
    };

    const openCloseDivisionProcess = (action: boolean) => {
        if (!division.sections || !division.sections.length) {
            return;
        }

        handleDivisionClicked();
        division.clicked = action;

        for (let j = 0; j < division.sections.length; j++) {
            const section = division.sections[j];
            handleSectionClicked(section.id);
            section.clicked = action;
        }
    };

    return (
        <DivisionItemWrapper className={division.clicked ? 'clicked' : ''}>
            <DivisionItemContainer>
                <DivisionTitleContainer>
                    <Switcher
                        id={division.id}
                        clicked={division.clicked}
                        handleSwitch={handleClicked}
                        width={24}
                        height={24}
                        onClick={() => {
                            handleClicked(division.id);
                        }}
                    />
                    <DivisionTitle
                        className="division-id hover"
                        onClick={() => {
                            handleClicked(division.id);
                        }}
                    >
                        {division.id[0] + division.id[1]}
                    </DivisionTitle>
                    <DivisionTitle
                        className="hover"
                        onClick={() => {
                            handleClicked(division.id);
                        }}
                    >
                        {division.name}
                    </DivisionTitle>
                    <Text
                        weight={400}
                        size={20}
                        height={24}
                        color={blueDark01}
                        className="hover"
                        onClick={() => {
                            handleClicked(division.id);
                        }}
                    >
                        (
                        {division.sections.reduce((agg, item) => {
                            agg += item.products.length;
                            return agg;
                        }, 0)}
                        )
                    </Text>
                    <InvisibleButton>
                        <OpenCloseDivisionButton
                            onClick={openCloseDivision}
                            className="closeOpenDivision"
                        >
                            <Text weight={400} size={12} height={14} color={blueLink}>
                                Open / close all
                            </Text>
                        </OpenCloseDivisionButton>
                    </InvisibleButton>
                </DivisionTitleContainer>
                <ExportDivisionImage
                    src="src/assets/images/file-division-export.svg"
                    title="Export division"
                    preview={false}
                    onClick={onToggle}
                />
            </DivisionItemContainer>
            <ProductSwitcherContent className={division.clicked ? 'clicked' : ''}>
                {division.sections.map((section, i) => (
                    <SectionItem
                        liveGuidelineId={liveGuidelineId}
                        section={section}
                        key={section.id}
                        canHideProducts={canHideProducts}
                        editable={editable}
                        references={references}
                        handleClicked={handleSectionClicked}
                        updateDivisions={updateDivisions}
                        handleDeleteProduct={handleDeleteProduct}
                        lastSection={i + 1 === division.sections.length}
                        brandsInfo={brandsInfo}
                        filterModalOpened={filterModalOpened}
                        handleSelectProduct={handleSelectProduct}
                        selectedProducts={selectedProducts}
                    />
                ))}
            </ProductSwitcherContent>
            {isOpen && (
                <LiveGuidelineExportModal
                    guideline={{ id: liveGuidelineId, name: liveGuidelineName }}
                    division={division}
                    isOpen={isOpen}
                    closeModal={onToggle}
                />
            )}
        </DivisionItemWrapper>
    );
};

export default GuidelineDivisionItem;
